import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Maren Okonkwo',
    description: 'Photographer. Five looks laid out on a cutting mat — pick one and the cut does the rest.',
    url: getOrigin()
}